import React from 'react';
import { POST_IMPORT_ROUTE_PERMISSIONS } from 'pages/StocksInRequest/utils/permissions';

const StocksInRequestPage = React.lazy(() => import('pages/StocksInRequest/StocksInRequestPage'));
const StocksInRequestAddPage = React.lazy(() => import('pages/StocksInRequest/StocksInRequestAddPage'));

const stocksInRequestRoute = [
  {
    path: '/stocks-in-request',
    exact: true,
    name: 'Nhập kho từ mua hàng',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: StocksInRequestPage,
  },
  {
    path: '/stocks-in-transfer-request',
    exact: true,
    name: 'Nhập kho do chuyển hàng',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: StocksInRequestPage,
  },
  {
    path: '/stocks-in-request/add',
    exact: true,
    name: 'Thêm mới phiếu nhập kho',
    function: ['ST_STOCKSINREQUEST_ADD', 'ST_STOCKSINREQUEST_IMPORT'],
    any: true,
    requireAssigned: true,
    component: StocksInRequestAddPage,
  },
  {
    path: '/stocks-in-request/detail/:stocks_in_request_id',
    exact: true,
    name: 'Chi tiết phiếu nhập kho',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: StocksInRequestAddPage,
  },
  {
    path: '/stocks-in-request/edit/:stocks_in_request_id',
    exact: true,
    name: 'Chỉnh sửa phiếu nhập kho',
    function: POST_IMPORT_ROUTE_PERMISSIONS,
    any: true,
    component: StocksInRequestAddPage,
  },
];

export default stocksInRequestRoute;
